<template>
  <div
    class="expertComment"
  >
    <div class="expertComment-close">
      <v-btn
        class="expertComment-close__button"
        icon
        x-small
        style="vertical-align: bottom;"
        @click="$emit('close')"
      >
        <v-icon v-text="'mdi-close'" />
      </v-btn>
    </div>
    <slot name="title">
      <h5
        class="expertComment-title"
        v-text="title"
      />
    </slot>
    <slot name="body">
      <div
        class="expertComment-content"
        v-text="textComment"
      />
    </slot>
    <slot name="footer">
      <div class="expertComment-footer">
        <v-btn
          class="expertComment-footer__button"
          icon
          x-small
          style="vertical-align: bottom;"
          @click="copyComment(textComment)"
        >
          <v-icon v-text="'mdi-content-copy'" />
        </v-btn>
      </div>
    </slot>
  </div>
</template>

<script>

export default {
  name: 'LKMunMehViewComment',
  props: {
    textComment: {
      type: String,
      default: void 0,
    },
    title: {
      type: String,
      default: void 0,
    },
  },
  methods: {
    async copyComment(comment) {
      try {
        await navigator.clipboard.writeText(comment)
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Ошибка копирования текста: ', err)
      }
    },
  },
}
</script>

<style lang="scss">
.expertComment {
  position: absolute;
  bottom: 100%;
  width: 49%;
  padding: 5px 16px;
  font-size: 14px;
  line-height: 22px;
  color: $color-white;
  text-transform: none;
  background: rgba(97, 97, 97, 0.9);
  border-radius: 8px;

  &-close {
    &__button {
      color: $color-white !important;
      cursor: pointer;
    }
  }

  &-title {
    text-align: start;
  }

  &-content {
    margin-bottom: 10px;
    text-align: start;
  }

  &-footer {
    &__button {
      color: $color-white !important;
      cursor: pointer;
    }
  }
}
</style>
